import { broadcastBaseModel } from './crud';
import { useFetchBroadcastsSuccessReport } from './fetchBroadcastsSuccessReport';

export * from './types';

export const useBroadcastsById = broadcastBaseModel.fetchById();
export const useBroadcastsByIds = broadcastBaseModel.fetchByIds();
export const useBroadcastsMany = broadcastBaseModel.fetchMany();
export const useBroadcastsCount = broadcastBaseModel.count();
export const useBroadcastsManyInfiniteQuery =
  broadcastBaseModel.fetchPaginated();
export const useBroadcastsUpdateOne = broadcastBaseModel.edit();
export const useBroadcastsCreateOne = broadcastBaseModel.create();
export const useBroadcastsRemoveOne = broadcastBaseModel.delete();
export const useBroadcastsRemoveByIds = broadcastBaseModel.deleteByIds();

export const useBroadcastsByIdV2 = broadcastBaseModel.fetchByIdV2();
export const useBroadcastsByIdsV2 = broadcastBaseModel.fetchByIdsV2();
export const useBroadcastsManyV2 = broadcastBaseModel.fetchManyV2();
export const useBroadcastsCountV2 = broadcastBaseModel.countV2();
export const useBroadcastsManyInfiniteQueryV2 =
  broadcastBaseModel.fetchPaginatedV2();
export const useBroadcastsUpdateOneV2 = broadcastBaseModel.editV2();
export const useBroadcastsCreateOneV2 = broadcastBaseModel.createV2();
export const useBroadcastsRemoveOneV2 = broadcastBaseModel.deleteV2();
export const useBroadcastsRemoveByIdsV2 = broadcastBaseModel.deleteByIdsV2();

export const useBroadcastsSuccessReport = useFetchBroadcastsSuccessReport;

// New names based on Mongoose queries

export const useBroadcastById = broadcastBaseModel.fetchById();
export const useBroadcastByIds = broadcastBaseModel.fetchByIds();
export const useBroadcastMany = broadcastBaseModel.fetchMany();
export const useBroadcastCount = broadcastBaseModel.count();
export const useBroadcastPagination = broadcastBaseModel.fetchPaginated();
export const useBroadcastUpdateOne = broadcastBaseModel.edit();
export const useBroadcastCreateOne = broadcastBaseModel.create();
export const useBroadcastRemoveOne = broadcastBaseModel.delete();
export const useBroadcastRemoveByIds = broadcastBaseModel.deleteByIds();

export const useBroadcastByIdV2 = broadcastBaseModel.fetchByIdV2();
export const useBroadcastByIdsV2 = broadcastBaseModel.fetchByIdsV2();
export const useBroadcastManyV2 = broadcastBaseModel.fetchManyV2();
export const useBroadcastCountV2 = broadcastBaseModel.countV2();
export const useBroadcastPaginationV2 = broadcastBaseModel.fetchPaginatedV2();
export const useBroadcastUpdateOneV2 = broadcastBaseModel.editV2();
export const useBroadcastCreateOneV2 = broadcastBaseModel.createV2();
export const useBroadcastRemoveOneV2 = broadcastBaseModel.deleteV2();
export const useBroadcastRemoveByIdsV2 = broadcastBaseModel.deleteByIdsV2();
